export interface ComscoreBeaconParams {
  contentType: string; // "show" | "movie"
  language: string; // e.g. "haryanvi"
  c5Code: string; // "02" (micro-drama) | "03" (long-form premium)
  contentSlug: string; // originalSlug
  segmentIndex: number; // 1-based (data.frag.sn + 1)
  totalSegments: number; // from LEVEL_SWITCHED
}

export function fireComscoreBeacon(params: ComscoreBeaconParams): void {
  try {
    if (typeof window !== "undefined" && (window as any).COMSCORE) {
      const c2 = process.env.NEXT_PUBLIC_COMSCORE_C2;
      if (!c2) return;
      (window as any).COMSCORE.beacon({
        c1: "1",
        c2,
        c3: params.contentType,
        c4: params.language,
        c5: params.c5Code,
        c6: params.contentSlug,
        c10: `${params.segmentIndex}-${params.totalSegments}`,
      });
    }
  } catch (_e) {
    // do not break playback
  }
}
